import { FC } from 'react';

import { Timeline } from '@/shared/ui';

import { StructuredReportsAndStudiesType } from '@/features/reportCards';

import { TIMELINE_ICON_BY_REPORT_TYPE } from '../../config';
import { useReportTimelineItem } from '../../hooks';
import { DetailsPopover } from '../DetailsPopover/DetailsPopover';
import { ReportCardFooter } from '../ReportCardFooter/ReportCardFooter';
import { ReportGenerationStatus } from '../ReportGenerationStatus/ReportGenerationStatus';

import styles from './ReportTimelineRow.module.scss';

type ReportTimelineRowProps = {
  structuredReportsAndStudies: StructuredReportsAndStudiesType;
  className?: string;
  showSource?: boolean;
  testID?: string;
};

export const ReportTimelineRow: FC<ReportTimelineRowProps> = (props) => {
  const { structuredReportsAndStudies, className, showSource, testID } = props;

  const item = useReportTimelineItem(structuredReportsAndStudies, {
    showSource,
  });

  if (!item) {
    return null;
  }

  return (
    <Timeline.Row
      className={className}
      dataComponent="report-timeline-row"
      time={item.time}
      icon={TIMELINE_ICON_BY_REPORT_TYPE[item.reportType]}
      title={item.title}
      meta={item.meta}
      preview={item.preview}
      isHidden={item.isHidden}
      isRemoving={item.isRemoving}
      testID={testID}
      actions={<DetailsPopover {...item.detailsPopoverProps} />}
      onAuxClick={item.handleAuxClick}
      onClick={item.handleCardClick}
    >
      {!item.isCompleted && (
        <ReportGenerationStatus
          report={item.report}
          className={styles.status}
          compact
        />
      )}

      <ReportCardFooter className={styles.footer} light {...item.footerProps} />
    </Timeline.Row>
  );
};
